import { LocalDictionaryFactory } from  '../../api/api.module'

import { LoggerService } from  '../../common/common.module'

import { IUserSession } from '../../../helpers/user-session'

import { TaskTypeDetailDirectiveController } from './tasks-types-details.directive.controller'

import { TaskTypeHelper } from '../tasks-types.helper'

//#region Asset Imports

import * as TEMPLATE from './tasks-types-details.tpl.html'

//#endregion 

// Setup

export class TaskTypeDetailsDirective implements ng.IDirective {
   
    restrict = 'E'

    scope = {
        id: '='
    }

    controller = ['$scope', '$q', '$timeout', 'logger', 'localDictionary', 'userSession', (
        $scope: any, 
        $q: ng.IQService, 
        $timeout: ng.ITimeoutService, 
        logger: LoggerService, 
        localDictionary: LocalDictionaryFactory, 
        userSession: IUserSession
    ) => new TaskTypeDetailDirectiveController(
        $scope,
        $q, 
        $timeout, 
        logger, 
        localDictionary,
        userSession, 
        TaskTypeHelper.REFERENCE_TYPE,
        TaskTypeHelper.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// Setup End